module.exports = __webpack_public_path__ + "img/news.caa9eac.webp";